import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  InboxOutlined,
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Button,
  Drawer,
  Image,
  Layout,
  Menu,
  Modal,
  theme,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserInfo } from "../../context";
import "./layout.css";
// import AccountDetails from "../merchant/account/AccountDetails";
import LOGO from "./../../assets/tinyimg/logo.webp";
import AccountDetails from "../storeadmin/account";

const { Header, Sider, Content, Footer } = Layout;

const StoreAdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(
    window.innerWidth > 635 ? false : true
  );
  const navtab = window.location.pathname === "/" ? "1" : "";
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const themeStyle = "dark";
  const [current, setCurrent] = useState("1");
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  const [accountDetailsDrawer, setAccountDetailsDrawer] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  function getItem(label, key, icon, children, disabled, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled,
    };
  }

  const items = [
    getItem(
      <Link to="/" relative="path">
        Merchant List
      </Link>,
      "1",
      <InboxOutlined />
    ),
  ];

  const MenuonClick = (e) => {
    setCurrent(e.key);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      handleLogoutTkn();
    }, 2000);
  };

  useEffect(() => {}, [current]);

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      hasSider={window.innerWidth > 500 ? true : false}
    >
      {window.innerWidth > 500 && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: themeStyle === "dark" ? "#001529" : "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: collapsed ? 45 : 100,
                width: collapsed ? 45 : 100,
                margin: 16,
                background: themeStyle === "dark" ? "transparent" : "#001529",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image
                width={"auto"}
                height={collapsed ? 45 : 100}
                src={LOGO}
                placeholder={"logo"}
                preview={false}
                alt="logo"
              />
            </div>
          </div>

          <Menu
            onClick={MenuonClick}
            defaultSelectedKeys={[navtab]}
            mode="inline"
            theme={themeStyle}
            items={items}
          />
        </Sider>
      )}

      <Layout
        className="container3"
        style={{
          marginLeft: window.innerWidth > 500 ? (collapsed ? 80 : 200) : 0,
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              {window.innerWidth > 500 ? (
                collapsed ? (
                  <MenuUnfoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                ) : (
                  <MenuFoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                )
              ) : (
                <MenuOutlined
                  style={{ marginLeft: 10, fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpenDrawer(!openDrawer)}
                />
              )}
            </div>
            <div style={{ marginRight: 20 }}>
              <Tooltip
                placement="bottomRight"
                title={"Account"}
                color={"#2db7f5"}
              >
                <UserOutlined
                  style={{ marginRight: 15, fontSize: 15 }}
                  className="trigger"
                  onClick={() => {
                    setAccountDetailsDrawer(true);
                  }}
                />
              </Tooltip>
              <Tooltip
                placement="bottomRight"
                title={"Logout"}
                color={"#2db7f5"}
              >
                <LogoutOutlined
                  style={{ fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpen(true)}
                />
              </Tooltip>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflow: "initial",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          DigiMenu ©2023 Created by Nehemiah Solutions
        </Footer>
      </Layout>

      <Drawer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        placement="left"
        closable={false}
        bodyStyle={{ backgroundColor: "#001529" }}
        width={220}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setOpenDrawer(false);
                }}
                style={{ color: "#fff", backgroundColor: "#001529" }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>

        <Menu
          onClick={MenuonClick}
          defaultSelectedKeys={[navtab]}
          mode="inline"
          theme={themeStyle}
          items={items}
        />
      </Drawer>

      <Modal
        title="Are you sure to logout?"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
        centered
        width={350}
      />

      {accountDetailsDrawer && (
        <AccountDetails
          open={accountDetailsDrawer}
          close={() => setAccountDetailsDrawer(false)}
        />
      )}
    </Layout>
  );
};
export default StoreAdminLayout;
